import { SystemUsageData } from "../../../../types"

interface Props {
  usage: SystemUsageData
}

const Disclaimer = ({ usage }: Props) => (
  <ul className="text-neutral-400 pt-8 text-sm">
    <li>* Payment is due within 30 days</li>
    <li>
      * If you have any questions concerning this invoice, contact{" "}
      <a href="mailto:support@bankingbridge.com">support@bankingbridge.com</a>
    </li>
    <li>
      * Email count includes all emails sent on your behalf to leads during the
      billing period.
    </li>
    <li>
      * You are only charged for the number of emails OVER your included amount:{" "}
      {usage?.pricing_details.included_emails}
    </li>
    <li>
      * You are only charged for the number of leads OVER your included amount:{" "}
      {usage?.pricing_details.included_leads}
    </li>
    <li>
      * You are only charged for the number of sms threads OVER your included
      amount: {usage?.pricing_details.included_sms_threads}
    </li>
    <li>
      * Lead count includes all leads captured on your behalf during the billing
      period.
    </li>
    <li></li>* Dollar amounts are rounded to the nearest whole dollar.
  </ul>
)

export default Disclaimer
